export const defaultStatusStyle = "text-xs font-medium leading-tight px-[10px] py-[2px] rounded-3xl absolute top-2 left-2";
